import React, { useState } from "react";
import { useDropzone } from "react-dropzone";
import { Image, Icon } from "semantic-ui-react";
import { toast } from "react-toastify";
import APIService from "../../Services/API/APIService";


const thumbsContainer = {
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  marginTop: 16,
};

const thumb = {
  display: "inline-flex",
  borderRadius: 2,
  border: "1px solid #eaeaea",
  marginBottom: 8,
  marginRight: 8,
  width: 100,
  height: 100,
  padding: 4,
  boxSizing: "border-box",
};

const thumbInner = {
  display: "flex",
  minWidth: 0,
  overflow: "hidden",
};

const img = {
  display: "block",
  width: "auto",
  height: "100%",
};

const FileUpload = (props) => {

  const [galleryItems, setGalleryItems] = useState(
    props?.images?.package?.GuestHouseGalleries
  );

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    onDrop: (acceptedFiles) => {
      //   console.log("acceptedFiles", acceptedFiles);
   
      props.setFiles([...props.files, ...acceptedFiles]);
    
    },
  });


  const _deleteImage = async (pictureGalleryId) => {
    try {
      let response = await APIService.postData(
        `/guest-house/deleteGuestHouseGallery`,
        {
          id: pictureGalleryId,
        }
      );

      if (response.success) {
        setGalleryItems(
          galleryItems.filter((item) => item.id !== pictureGalleryId)
        );
        toast.success(`Item deleted`);
      } else {
        toast.warn(`Failed to delete item`);
      }
    } catch (error) {
      console.log("error", error);
      // setLoading(false);
      toast.warn(`An error occurred`);
    }
  };

  const _deletePreview = async (filename) => {
    props.setFiles(props.files.filter((item) => item.name !== filename));
  };

  const gallery = galleryItems?.map((file) => (
    <div style={thumb} key={file.id}>
      <div style={thumbInner}>
        <Image src={file.resizeLocation} style={img} />

        {/* <Label color="green" empty corner circular /> */}
      </div>

      <div as="a">
        <Icon
          name="delete"
          color="red"
          size="large"
          onClick={() => {
            _deleteImage(file.id);
          }}
        />
      </div>
    </div>
  ));

  const previews = props.files?.map((file) => (
 
    <div style={thumb} key={file.name}>
      <div style={thumbInner}>
        <img src={URL.createObjectURL(file)} style={img} alt="" />
      </div>
      <Icon
        name="delete"
        color="red"
        size="large"
        onClick={() => {
          _deletePreview(file.name);
        }}
      />
    </div>
  ));

  return (
    <section className="container">
      <div
        {...getRootProps({ className: "dropzone" })}
        style={{
          border: "1px dashed black",
          marginBottom: "5px",
          padding: "10px",
        }}
      >
        <input {...getInputProps()} />
        <p>
          Drag and drop up to 10 image files here, or click to select the files
          (10MB max)
        </p>
      </div>
      <aside style={thumbsContainer}>
        {gallery}
        {previews}
      </aside>
    </section>
  );
};

export default FileUpload;
